import React, { forwardRef } from "react";
import { faGripVertical, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const Comment = forwardRef(
  ({ serialNumber, date, id, index, dragHandleProps, snapshot, removeItem, ...props }, ref) => {
    return (
      <li
        ref={ref}
        {...props}
        className={
          "comment card p-2 my-2 " + (snapshot.isDragging ? "hovering" : "")
        }
      >
        <div className="d-flex align-items-top">
          <span {...dragHandleProps}>
            <FontAwesomeIcon icon={faGripVertical} className="mr-2" />
          </span>
          <div className="d-flex justify-content-between w-100">
            <small className="ml-2 text-dark">{serialNumber}</small>
            <FontAwesomeIcon icon={faTimes} className="cursor-pointer" onClick={() => removeItem(index)} />
          </div>
        </div>
        <div className="text-muted text-right">
          <small className="bold">Priority {index + 1}</small>
        </div>
      </li>
    );
  }
);

export default Comment;
